import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { IPermisiune, IPermisiuneAddPayload, IPermisiuneUpdatePayload } from './permisiuni.interface';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PermisiuniService {
  private token!: string;
  private basePath = environment.interop.basePath;
	private httpOptions: any;
	private getPermisiuniListUrl = this.basePath + environment.interop.platform.nomenclatoare.permissions.getUserPermissions;
	private getPermisiuniDTUrl = this.basePath + environment.interop.platform.nomenclatoare.permissions.getUserPermissions + '-dt';
	private storePermisiuneUrl = this.basePath + environment.interop.platform.nomenclatoare.permissions.storeUserPermission;
	private updatePermisiuneUrl = this.basePath + 'api/nomenclatoare/permission/update';
	private changeStatusPermisiuneActiveUrl = this.basePath + environment.interop.platform.nomenclatoare.permissions.changeStatusUserPermissionActive;
	private changeStatusPermisiunePublicUrl = this.basePath + environment.interop.platform.nomenclatoare.permissions.changeStatusUserPermissionPublic;
	private deletePermisiuneUrl = this.basePath + environment.interop.platform.nomenclatoare.permissions.deleteUserPermission;
	private getPermisiuniActiveUrl = this.basePath + environment.interop.platform.nomenclatoare.permissions.getUserPermissionsActive;
	private getPermisiuniPublicUrl = this.basePath + environment.interop.platform.nomenclatoare.permissions.getUserPermissionsActivePublic;

  constructor(private http: HttpClient) { }

  getPermisiuniList(): Observable<IPermisiune[]> {
	  return this.http.get(this.getPermisiuniListUrl, this.httpOptions).pipe(map((res: any) => res.data));
  }

  getPermisiuniDT() {
		return this.http.get(this.getPermisiuniDTUrl, this.httpOptions);
	}

	addPermisiune(data: IPermisiuneAddPayload) {
		return this.http.post(this.storePermisiuneUrl, data, this.httpOptions);
	}

	updatePermisiune(data: IPermisiuneUpdatePayload) {
		return this.http.put(this.updatePermisiuneUrl, data, this.httpOptions);
	}

	deletePermisiune(id: number) {
		return this.http.delete(this.deletePermisiuneUrl + id);
	}

	getPermisiuniActive() {
		return this.http.get(this.getPermisiuniActiveUrl, this.httpOptions);
	}

	getPermisiuniPublic() {
		return this.http.get(this.getPermisiuniPublicUrl, this.httpOptions);
	}

	setToken(token: string) {
		this.token = token;
		this.httpOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json',
				'Accept': 'application/json',
				'Authorization': `Bearer ${this.token}`
			})
		};
	}
}
